import { EnumTypeComposer, NamedTypeComposer } from "graphql-compose";
export { isObjectType } from "vl-app-client/lib/cms/schema/getObjectTypes";

export const isEnumType = (
  value: NamedTypeComposer<any>,
): value is EnumTypeComposer => value.schemaComposer.isEnumType(value);
